import { HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { delay, switchMap } from 'rxjs/operators';

// Mock data
const REWARDS_DATA = {
  pointsBalance: 1250,
  transactions: [
    { 
      id: '1', 
      date: '2025-06-01', 
      type: 'Earned', 
      description: 'Product Purchase', 
      points: 100, 
      balance: 1250 
    },
    { 
      id: '2', 
      date: '2025-05-15', 
      type: 'Redeemed', 
      description: 'Gift Card Redemption', 
      points: -50, 
      balance: 1150 
    }
  ]
};

const COMMISSION_DATA = {
  commissionHistory: [
    { 
      id: '1', 
      date: '2025-06-05', 
      source: 'Direct Sales', 
      description: 'Commission from Product X', 
      amount: 125.50, 
      status: 'Paid' 
    },
    { 
      id: '2', 
      date: '2025-05-20', 
      source: 'Team Sales', 
      description: 'Downline commission', 
      amount: 75.25, 
      status: 'Pending' 
    }
  ]
};

export const LocalDataInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<any> => {
  // Only intercept requests if the environment flag is set
  if (!environment.useLocalData) {
    return next(req);
  }

  // Check if request URL contains the modules we want to intercept
  if (req.url.includes('/rewards') && req.method === 'GET') {
    
    return of(new HttpResponse({ status: 200, body: REWARDS_DATA }))
      .pipe(delay(500)); // Add artificial delay
  }
  
  if (req.url.includes('/commission') && req.method === 'GET') {
    
    return of(new HttpResponse({ status: 200, body: COMMISSION_DATA }))
      .pipe(delay(500)); // Add artificial delay
  }

  // Pass through any requests not handled above
  return next(req);
}
